module.exports = __webpack_public_path__ + "static/img/18.82d73be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/eng/18.png
// module id = 2vIO
// module chunks = 0